import { RawClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { clientConfiguration as stagingClientConfiguration } from "@common/configuration/environment.base.staging";
import { clientConfiguration } from "./environment.base";

export const environment = {
    production: true,
    clientConfiguration: Object.assign(
        {},
        clientConfiguration,
        stagingClientConfiguration,
    ) as Partial<RawClientConfiguration>,
};
